import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { FirebaseAuthService } from '../../login/services/firebase-auth.service';
import { LoginService } from '../../login/services/login.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-balance-popover',
  templateUrl: './balance-popover.component.html',
  styleUrls: ['./balance-popover.component.scss'],
})
export class BalancePopoverComponent implements OnInit {
  @Input() resData: any = {};
  @Input() avatar: string;
  @Input() name: string;
  @Input() logined = true;
  isAdmin;
  constructor(
    private router: Router,
    private popoverCtrl: PopoverController,
    private loginService: LoginService,
    private fbAuth:FirebaseAuthService,
    private storageService:StorageService
  ) {}

  async ngOnInit() {
    const user = await this.storageService.get('userLogin') || null;
    if(user){
      this.isAdmin = user.rol_id;
    }
  }

  async goToRoute(route) {
    this.popoverCtrl.dismiss();
    if (route === 'logout'){
      await this.fbAuth.signOutApp()
      return this.loginService.logOut()
    };
    this.router.navigate([route]);
  }

  fixText(text: string) {
    if (text.length > 7) {
      return `${text.slice(0, 7)}...`;
    } else {
      return text;
    }
  }
}
